export const convertStringToArray = (string: string) => {
  return string.replace(/ |[\n]|\[|\]|\"/g, '').split(",")
}

export const shuffleArray = list => { 
  for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = list[i];
      list[i] = list[j];
      list[j] = temp;
  }
  return list
}

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const colorArrayToString = (a) => {
  return `rgba(${a.red},${a.green},${a.blue},${a.alpha})`
}

export const truncate = (str, num) => {
  if (str.length <= num) {
    return str
  }
  return str.slice(0, num) + '...'
}

export const determineTextColor = (color: string): string => {
  let r: number, g: number, b: number;

  if (color.startsWith("#")) {
      // Convert hex to RGB values
      r = parseInt(color.slice(1, 3), 16);
      g = parseInt(color.slice(3, 5), 16);
      b = parseInt(color.slice(5, 7), 16);
  } else if (color.startsWith("rgb")) {
      // Check for rgba format
      const rgbaMatch = /rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/.exec(color);
      if (rgbaMatch) {
          [r, g, b] = rgbaMatch.slice(1, 4).map(num => parseInt(num, 10)) as [number, number, number];
      } else {
          // If not rgba, check for rgb format
          const rgbMatch = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/.exec(color);
          if (!rgbMatch) return 'black'; // default value
          [r, g, b] = rgbMatch.slice(1, 4).map(num => parseInt(num, 10)) as [number, number, number];
      }
  } else {
      return 'black'; // default value
  }

  // Calculate the brightness of the color
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is above the threshold (in this case, 128), return black, else return white
  return brightness > 128 ? 'black' : 'white';
};